import { useMutation } from "react-query";
import { GrupoUnidadeForm, GrupoUnidadeSaveResponse } from "../typings";
import http from "infra/http";

function useSaveGrupoUnidade() {
  return useMutation(
    (data: GrupoUnidadeForm) => {
      if (data.id) {
        return http.put<GrupoUnidadeSaveResponse>(`/v1/grupo-unidade/${data.id}`, data);
      }

      return http.post<GrupoUnidadeSaveResponse>(`/v1/grupo-unidade`, data);
    },
    { retry: false }
  );
}

export default useSaveGrupoUnidade;
